import React from "react";
import { TextField, InputAdornment, IconButton } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import { getTranslation } from "common";
import { useTranslations } from "hooks";

interface MonitorSearchBarProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  sx?: any;
}

const MonitorSearchBar: React.FC<MonitorSearchBarProps> = ({
  value,
  onChange,
  placeholder,
  sx,
}) => {
  const translations = useTranslations();

  return (
    <TextField
      id="search-tasks-text-monitor"
      size="small"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={
        placeholder ||
        getTranslation(translations, "pm.organizationchart.ricerca.placeholder")
      }
      sx={{
        width: 150,
        backgroundColor: "white",
        borderRadius: 1,
        "& .MuiOutlinedInput-root": {
          "& fieldset": {
            borderColor: "rgba(0, 0, 0, 0.23)",
          },
          "&:hover fieldset": {
            borderColor: "primary.main",
          },
        },
        ...sx,
      }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon color="action" />
          </InputAdornment>
        ),
        endAdornment: value ? (
          <InputAdornment position="end">
            <IconButton
              size="small"
              onClick={() => onChange("")}
              edge="end"
            >
              <ClearIcon fontSize="small" />
            </IconButton>
          </InputAdornment>
        ) : null,
      }}
    />
  );
};

export default MonitorSearchBar;
